module.exports = new __parcel__URL__("Retro Hover.17d739ed.svg").toString();